import { Link, useLocation } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import { Wordmark } from "./Wordmark";

export const Footer = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return (
  <footer className="bg-charcoal text-cream" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Wordmark size="base" tagline className="[&_.text-wine]:!text-cream [&_.text-terracotta]:!text-blush" />
          <p className="mt-8 max-w-md text-cream/70 font-light leading-relaxed">
            Leadership and career strategy for ambitious mothers navigating what comes next.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-gold mb-6">Explore</p>
          <ul className="space-y-4">
            <li><Link to="/" data-testid="footer-home" className="text-cream/80 hover:text-blush transition-colors">Home</Link></li>
            <li><Link to="/about" data-testid="footer-about" className="text-cream/80 hover:text-blush transition-colors">About</Link></li>
            <li><Link to="/method" data-testid="footer-method" className="text-cream/80 hover:text-blush transition-colors">The Method</Link></li>
            <li><Link to="/lead" data-testid="footer-work-with" className="text-cream/80 hover:text-blush transition-colors">Work With Jenna</Link></li>
            <li><Link to="/shop" data-testid="footer-shop" className="text-cream/80 hover:text-blush transition-colors">Resources</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-gold mb-6">Connect</p>
          <a
            href="https://instagram.com/thriveandmotherco"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-3 text-cream/80 hover:text-blush transition-colors"
          >
            <Instagram size={18} /> @thriveandmotherco
          </a>
          <a
            href="https://www.linkedin.com/company/the-thrive-mother-company"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            className="flex items-center gap-3 mt-4 text-cream/80 hover:text-blush transition-colors"
          >
            <Linkedin size={18} /> The Thrive &amp; Mother Company
          </a>
          <a
            href="mailto:jenna@thriveandmother.com"
            data-testid="footer-email"
            className="block mt-4 text-cream/80 hover:text-blush transition-colors"
          >
            jenna@thriveandmother.com
          </a>
        </div>
      </div>

      <div className="mt-16 pt-10 border-t border-cream/15">
        <p className="text-center font-serif font-light text-cream/90 text-xl md:text-2xl leading-relaxed tracking-wide" data-testid="footer-tagline">
          Lead boldly. <span className="text-blush">Live intentionally.</span> <span className="text-gold">Thrive fully.</span>
        </p>
        <div className="mt-10 pt-6 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/50">
          <p>© {new Date().getFullYear()} The Thrive &amp; Mother Company, LLC. All rights reserved. Motherhood Is Leadership™, The RESET Method™, The Outcome-led Professional™, and The Thrive &amp; Mother Framework™ are trademarks of The Thrive &amp; Mother Company, LLC.</p>
          <p className="uppercase tracking-[0.2em]">Systems Create Freedom</p>
        </div>
      </div>
    </div>
  </footer>
  );
};
